"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantUsagePanel = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const _ui_1 = require("@ui");
const util_1 = require("@app/util");
require("./assistant-usage-panel.scss");
/**
 * What the workspace's consumption means, in words: how many conversations are gone, when the
 * credits behind them lapse, and the fact that they belong to the whole workspace rather than to
 * the manager reading it.
 *
 * Every figure comes from the caller. `usedPercent` is used exactly as given rather than
 * recomputed, so the bar and the ring cannot disagree.
 */
const AssistantUsagePanel = ({ usage, panelRef, onClose, onBuyCredits, }) => {
    const { used, limit, usedPercent, nearestExpiry } = usage;
    const isSpent = used >= limit;
    return (react_1.default.createElement("div", { className: 'ds-ma-usage-panel', "data-testid": 'ai-usage-panel', ref: panelRef, role: 'dialog', "aria-label": (0, util_1.t)('ASSISTANT.usagePanelTitle') ?? undefined },
        react_1.default.createElement("div", { className: 'ds-ma-usage-panel-head' },
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.MEDIUM }, (0, util_1.t)('ASSISTANT.usagePanelTitle')),
            react_1.default.createElement("button", { type: 'button', className: 'ds-ma-usage-panel-close', onClick: onClose, "aria-label": (0, util_1.t)('CLOSE') ?? undefined, title: (0, util_1.t)('CLOSE') ?? undefined },
                react_1.default.createElement(_ui_1.Icon, { ico: 'close4', size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.INHERIT }))),
        react_1.default.createElement("div", { className: 'ds-ma-usage-panel-row' },
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.MEDIUM }, (0, util_1.t)('ASSISTANT.usageConversations')),
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.SEMI_BOLD }, `${used} / ${limit}`)),
        react_1.default.createElement("div", { className: 'ds-ma-usage-panel-track' },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('ds-ma-usage-panel-bar', { 'is-spent': isSpent }), style: { width: `${usedPercent}%` } })),
        isSpent && (react_1.default.createElement("span", { className: 'ds-ma-usage-panel-note is-spent' }, (0, util_1.t)('ASSISTANT.usageQuotaExhausted'))),
        (0, util_1.isValue)(nearestExpiry) && (react_1.default.createElement("span", { className: 'ds-ma-usage-panel-note' }, (0, util_1.t)('ASSISTANT.usageCreditsExpireOn', {
            date: (0, moment_1.default)(nearestExpiry).format('L'),
        }))),
        react_1.default.createElement("span", { className: 'ds-ma-usage-panel-note' }, (0, util_1.t)('ASSISTANT.usageQuotaIsShared')),
        (0, util_1.isValue)(onBuyCredits) && (react_1.default.createElement("div", { className: 'ds-ma-usage-panel-action' },
            react_1.default.createElement(_ui_1.Button, { label: (0, util_1.t)('ASSISTANT.usageBuyCredits'), onClick: onBuyCredits, size: _ui_1.Button.SIZES.SMALL, style: _ui_1.Button.STYLES.CONTAINED })))));
};
exports.AssistantUsagePanel = AssistantUsagePanel;
exports.default = AssistantUsagePanel;
